require('es5-shim');
require('json3');
require('fetch-ie8');
require('es6-shim');
require('polyfill-function-prototype-bind');

if (Object.assign === undefined)
{
    Object.assign = require('object-assign');
}



// WEBPACK FOOTER //
// ./common/js/lib/preactPolyfills.js